
import { request, get } from './';

const add = async (phone) => {
    const result = await request('/invites/add', { phone });
    return result.data;
};

const ip = async identifier => {
    const result = await get('/invites/ip');
    return result.data;
};

const fetch = async identifier => {
    const result = await request('/invites/suggest', { identifier });
    return result.data;
};

export default { add, fetch, ip };
